import { render, staticRenderFns } from "./ClickToEdit.vue?vue&type=template&id=13bdacac&scoped=true"
import script from "./ClickToEdit.vue?vue&type=script&lang=js"
export * from "./ClickToEdit.vue?vue&type=script&lang=js"
import style0 from "./ClickToEdit.vue?vue&type=style&index=0&id=13bdacac&prod&scoped=true&lang=scss"
import style1 from "./ClickToEdit.vue?vue&type=style&index=1&id=13bdacac&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bdacac",
  null
  
)

export default component.exports